import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { regenerateMediumSlots } from "../../../../services/admin";
import CopyComponent from "../../../../components/copyComponent";
import Sorting from "../../../../components/sorting";
import UserStatus from "../../../../components/userstatus";
import Pagination from "../../../../components/tablePagination";
import { getMediumRole } from "../../../../utils/utils";
import Checkbox from "../../Subcomponents/checkbox";
import ToggleTestUser from "../../Subcomponents/toogletestuser";
// import PaginatedItems from '../../../../components/pagination';
import { setMediumPage, setMediumrowsPerPage, setPathArray } from "../../../../reducer/adminSlice";
import FraudSignalBadge from "../../../../components/fraudsignalbadge";
import MediumInfoPanel from "../MediumInfoPanel";

export default function Medium(props) {
  const navigate = useNavigate();

  const {
    allMediumCount,
    allMediumCountPage,
  } = useSelector((state) => state.users);
  const {
    mediums,
    updateUser,
    onClickHandler,
    filterListMediums,
    filterReset,
    bulkActions,
    getPaginationData,
    mediumpage,
    mediumrowsPerPage,
    setFilterValues,
    setSearchValues,
    searchValue,
    filterValues,

    setOptionsList,
    optionsList,
    operatorList,
    setOperatorList,
    showOprater,
    setShowOprater,
    setFilterOprater,
    filterOprater,
    setFilterValueOptions,
    filterValueOptions,
    isSearching,
    checked,
    setChecked,
    selected,
    setSelected,
  } = props;
  const dispatch = useDispatch()

  const [panelMedium, setPanelMedium] = useState(null);
  const [panelDetails, setPanelDetails] = useState(null);
  const [panelLoading, setPanelLoading] = useState(false);
  const [recalculatingSlots, setRecalculatingSlots] = useState(false);

  const getInitials = (name) => {
    if (!name) return '?';
    const parts = name.trim().split(' ').filter(Boolean);
    if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
    return name.substring(0, 2).toUpperCase();
  };
  const getAvatarStyle = (name) => {
    const palettes = [
      { background: '#f5e6d8', color: '#b87040' },
      { background: '#faf0e8', color: '#c07838' },
      { background: '#eeddd0', color: '#a86030' },
      { background: '#f7ece0', color: '#d5a67b' },
      { background: '#f0e0cc', color: '#b87848' },
    ];
    const idx = name ? name.charCodeAt(0) % palettes.length : 0;
    return palettes[idx];
  };

  const [searchParams] = useSearchParams();
  const page = searchParams.get('page');
  const rowperpage = searchParams.get('rowperpage');


  useEffect(() => {

    if (page !== null) {

      dispatch(setMediumPage(page));

    }
    if (rowperpage !== null) {
      dispatch(setMediumrowsPerPage(rowperpage));
    }
  }, [])
  let info = JSON.parse(localStorage.getItem('pagination'))
  const navigateUser = (id) => {
    window.renderFirst = false
    dispatch(setPathArray(id.id));
    navigate(`/profile-view/${id.id}?view=0&search=${filterValues}&searchName=${Object.values(searchValue)}&page=${info.page}&rowperpage=${info.rowsPerPage}&searchOprator=${showOprater}&searchFilterOprater=${filterOprater}`);
  };
  const navigateEdit = (e, id) => {
    window.renderFirst = false
    if (e.target.className == "capitalize") {
      navigate(`/profile-edit/${id.id}?view=0&search=${filterValues}&searchName=${Object.values(searchValue)}&page=${info.page}&rowperpage=${info.rowsPerPage}&searchOprator=${showOprater}&searchFilterOprater=${filterOprater}`);
    } else {
    }

  };
  const navigateUserPricing = (id) => {
    window.renderFirst = false
    dispatch(setPathArray(id.id));
    navigate(`/pricing-view/${id.id}?view=0&search=${filterValues}&searchName=${Object.values(searchValue)}&page=${info.page}&rowperpage=${info.rowsPerPage}&searchOprator=${showOprater}&searchFilterOprater=${filterOprater}`);
  };
  const handleScreenNameClick = function(e, item) {
    e.stopPropagation();
    setPanelMedium(item);
    setPanelDetails({ general: { phone: item.phone || '', whatsapp: item.whatsapp || '', country: item.country || '', timezone: item.timezone || '', timezone_label: item.timezone_label || '', created_at: item.created_at || '' } });
    setPanelLoading(false);
    setRecalculatingSlots(false);
  };
  const handleRecalculateSlots = function(medium) {
    if (!medium || recalculatingSlots) return;
    setRecalculatingSlots(true);
    regenerateMediumSlots(medium.id)
      .then(function(res) {
        setRecalculatingSlots(false);
        if (res && res.data && res.data.status) {
          toast.success(res.data.message || 'Slot recalculation queued', { position: 'top-center' });
        } else {
          toast.error((res && res.data && res.data.message) || 'Failed to queue slot recalculation', { position: 'top-center' });
        }
      })
      .catch(function() {
        setRecalculatingSlots(false);
        toast.error('Failed to queue slot recalculation', { position: 'top-center' });
      });
  };
  const handleEditClick = (e, id) => {
    e.stopPropagation();
    window.renderFirst = false;
    navigate(`/profile-edit/${id.id}?view=0&search=${filterValues}&searchName=${Object.values(searchValue)}&page=${info.page}&rowperpage=${info.rowsPerPage}&searchOprator=${showOprater}&searchFilterOprater=${filterOprater}`);
  };
  const checkBoxChangeHandler = (e) => {

    setChecked(e.target.checked);
    if (e.target.checked) {
      let result = mediums.map((a) => a.id);
      setSelected(result);
    } else {
      setSelected([]);
    }
  };

  // const getPaginationData = (item) => {
  //  console.log('paginationdata',item);
  //  getFromToData(item);
  // };

  var panelActions = panelMedium ? [
    { label: 'Schedule', variant: 'default', onClick: function(e) { e.stopPropagation(); window.renderFirst = false; navigate('/services?schedule=schedule&id=' + panelMedium.id + '&view=0&level=' + panelMedium.current_mediumship_level + '&search=' + filterValues + '&searchName=' + Object.values(searchValue) + '&page=' + info.page + '&rowperpage=' + info.rowsPerPage + '&searchOprator=' + showOprater + '&searchFilterOprater=' + filterOprater); setPanelMedium(null); } },
    { label: 'Schedule Status', variant: 'default', onClick: function(e) { e.stopPropagation(); window.renderFirst = false; navigate('/schedule-status/' + panelMedium.id + '?view=0&level=' + panelMedium.current_mediumship_level + '&search=' + filterValues + '&searchName=' + Object.values(searchValue) + '&page=' + info.page + '&rowperpage=' + info.rowsPerPage + '&screen_Name=' + panelMedium.screen_name + '&searchOprator=' + showOprater + '&searchFilterOprater=' + filterOprater); setPanelMedium(null); } },
    { label: 'Calendar', variant: 'default', onClick: function(e) { e.stopPropagation(); window.renderFirst = false; navigate('/availability/' + panelMedium.id + '?&view=0&search=' + filterValues + '&searchName=' + Object.values(searchValue) + '&page=' + info.page + '&rowperpage=' + info.rowsPerPage); setPanelMedium(null); } },
  ].concat(
    ![1,2,4].includes(panelMedium.current_mediumship_level) ? [{ label: 'BackFill', variant: 'default', onClick: function(e) { e.stopPropagation(); window.renderFirst = false; navigate('/backfill-view/' + panelMedium.id + '?view=0&search=' + filterValues + '&searchName=' + Object.values(searchValue) + '&page=' + info.page + '&rowperpage=' + info.rowsPerPage + '&searchOprator=' + showOprater + '&searchFilterOprater=' + filterOprater); setPanelMedium(null); } }] : []
  ).concat([
    { label: 'View Profile', variant: 'primary', onClick: function(e) { e.stopPropagation(); window.open('/public-view/' + panelMedium.id, '_blank'); setPanelMedium(null); } },
    { label: 'Edit Profile', variant: 'primary', onClick: function(e) { e.stopPropagation(); window.renderFirst = false; navigate('/profile-edit/' + panelMedium.id + '?view=0&search=' + filterValues + '&searchName=' + Object.values(searchValue) + '&page=' + info.page + '&rowperpage=' + info.rowsPerPage + '&searchOprator=' + showOprater + '&searchFilterOprater=' + filterOprater); setPanelMedium(null); } },
    { label: 'Pricing', variant: 'default', onClick: function(e) { e.stopPropagation(); window.renderFirst = false; dispatch(setPathArray(panelMedium.id)); navigate('/pricing-view/' + panelMedium.id + '?view=0&search=' + filterValues + '&searchName=' + Object.values(searchValue) + '&page=' + info.page + '&rowperpage=' + info.rowsPerPage + '&searchOprator=' + showOprater + '&searchFilterOprater=' + filterOprater); setPanelMedium(null); } },
  ]).concat(
    // Share it Forward only applies to Intermediate II and Professional
    // I/II/III (current_mediumship_level 5/3/6/7) — NOT Intermediate I
    // (level 2) — same levels covered by the dedicated
    // intermediate/professional list pages' own panels. This "All Mediums"
    // tab spans every level (including Novice I/II and Support), so the
    // button is gated here instead of always shown.
    [3, 5, 6, 7].includes(panelMedium.current_mediumship_level)
      ? [{ label: 'Share it Forward', variant: 'default', onClick: function(e) { e.stopPropagation(); window.renderFirst = false; navigate('/share-it-forward/' + panelMedium.id + '?name=' + encodeURIComponent(panelMedium.screen_name || '')); setPanelMedium(null); } }]
      : []
  ).concat([
    { label: recalculatingSlots ? 'Recalculating…' : 'Recalculate Slots', variant: 'success', disabled: recalculatingSlots, onClick: function(e) { e.stopPropagation(); handleRecalculateSlots(panelMedium); } },
    { label: parseInt(panelMedium.status_name) === 4 ? 'UnRestrict' : 'Restrict', variant: 'warning', onClick: function(e) { e.stopPropagation(); updateUser(panelMedium, parseInt(panelMedium.status_name) === 4 ? 1 : 4, 'medium', ''); setPanelMedium(null); } },
    { label: 'Delete', variant: 'danger', onClick: function(e) { e.stopPropagation(); updateUser(panelMedium, 3, 'delete', ''); setPanelMedium(null); } },
  ]) : [];

  return (

    <>
      <div className="table-box-medium">
        <table className="caseTable">
          <tbody>
            <tr className="dark">
              <th >
                <input
                  onChange={(e) => checkBoxChangeHandler(e)}
                  type="checkbox"
                  id="one"
                />
                <label htmlFor="one"></label>
                &nbsp;
              </th>
              <th>
                {" "}
                <div className="d-flex align-items-center">
                  {" "}
                  <span className="scren-name">Screen Name & Email</span>{" "}
                  <Sorting callApi={filterListMediums} />
                </div>
              </th>
              <th>Test User</th>
              <th>Starter Referral Code</th>
              {/* <th>Total Starter Referrals</th> */}
              <th>Approved Role</th>
              <th>Status</th>
              <th>Online status</th>
              <th>Fraud Risk</th>
              <th>Action</th>
              {/* <th className="text-right">Actions</th> */}
            </tr>
             {isSearching ? (
              <tr>
              <td colSpan="12" className="text-center py-4">
                <div className="custom-loader">
                  <div className="loader-dot"></div>
                  <div className="loader-dot"></div>
                  <div className="loader-dot"></div>
                </div>
                <div className="loader-text mt-2">Loading mediums...</div>
              </td>
            </tr>
              )
            : mediums.length > 0 ? (
              mediums.map((medium) => (
                <tr
                  className="innr"
                >
                  <td className="">
                    <Checkbox
                      medium={medium}
                      status={checked}
                      selected={selected}
                      setSelected={setSelected}
                    />
                  </td>
                  <td onClick={(e) => handleScreenNameClick(e, medium)} className="pointer">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <div
                        className="medium-avatar"
                        style={medium.profile_image ? { width: 36, height: 36, borderRadius: '50%', overflow: 'hidden', display: 'inline-flex', flexShrink: 0 } : getAvatarStyle(medium.screen_name)}
                      >
                        {medium.profile_image ? (
                          <img
                            src={process.env.REACT_APP_IMAGE_URL + medium.profile_image}
                            alt={medium.screen_name}
                            style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }}
                          />
                        ) : getInitials(medium.screen_name)}
                      </div>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                        <div>
                          <span className="screen-name-link" style={{ textTransform: 'capitalize' }} onClick={(e) => handleScreenNameClick(e, medium)}>
                            {medium.screen_name ? medium.screen_name : "N/A"}
                          </span>
                          {(medium.comments != null && medium.comments !== "") && (<b style={{ fontSize: '22px' }}>*</b>)}
                        </div>
                        <div style={{ fontSize: '12px', color: '#888', textTransform: 'none' }}>
                          {medium.email}<CopyComponent value={medium.email} />
                        </div>
                      </div>
                    </div>
                  </td>
                  <td><ToggleTestUser
                    clientId={medium.id}
                    initialStatus={medium.test_user === 1} // Set initial toggle state
                    onStatusChange={(id, newStatus) => {
                      console.log(`Client ${id} status changed to ${newStatus ? 'on' : 'off'}`);
                      // Additional handling if necessary
                    }}/></td>
                  <td>
                    {medium.refer_code ? medium.refer_code : "-"}

                  </td>
                  {/* <td>
                    {medium.number_of_uses}

                  </td> */}
                  <td className="change">
                    <em>{getMediumRole(medium.current_mediumship_level)}</em>
                    {/* <a href="#">Change</a> */}
                  </td>

                  <td>
                    <span className={`medium-status-badge ${
                      parseInt(medium.status_name) === 1 ? 'status-approved' :
                      parseInt(medium.status_name) === 2 ? 'status-declined' :
                      parseInt(medium.status_name) === 4 ? 'status-restricted' :
                      'status-pending'
                    }`}>
                      {parseInt(medium.status_name) === 1 ? 'Approved' :
                       parseInt(medium.status_name) === 2 ? 'Declined' :
                       parseInt(medium.status_name) === 4 ? 'Restricted' :
                       'Pending'}
                    </span>
                  </td>
                  <td>
                    <UserStatus status={medium.is_available} />
                  </td>
                  <td><FraudSignalBadge client={medium} userType="medium" /></td>
                  <td>
                    <button
                      onClick={(e) => handleEditClick(e, medium)}
                      style={{ padding: '5px 14px', fontSize: '12px', fontWeight: '600', background: '#d5a67b', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer', whiteSpace: 'nowrap' }}
                    >
                      Edit
                    </button>
                  </td>
                  {/* <td className="dott">
                    <img
                      onClick={(e) => onClickHandler(e, medium.id, "mediums")}
                      src="/images/Unionblck.png"
                      className="padding-10"
                      alt="dots"
                    />
                    {medium.status && (
                      <div className="approve-btn-1 approve-btn z-index-1">
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            window.renderFirst = false;
                            navigate(
                              `/services?schedule=schedule&id=${medium.id}&view=0&level=${medium.current_mediumship_level}&search=${filterValues}&searchName=${Object.values(searchValue)}&page=${info.page}&rowperpage=${info.rowsPerPage}&searchOprator=${showOprater}&searchFilterOprater=${filterOprater}`
                            );
                          }}
                        >
                          Schedule
                        </span>
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            window.renderFirst = false;
                            navigate(
                              `/schedule-status/${medium.id}?view=0&level=${medium.current_mediumship_level}&search=${filterValues}&searchName=${Object.values(searchValue)}&page=${info.page}&rowperpage=${info.rowsPerPage}&screen_Name=${medium.screen_name}&searchOprator=${showOprater}&searchFilterOprater=${filterOprater}`
                            );
                          }}
                        >
                          Schedule status
                        </span>
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            window.renderFirst = false;
                            navigate(
                              `/availability/${medium.id}?&view=0&search=${filterValues}&searchName=${Object.values(searchValue)}&page=${info.page}&rowperpage=${info.rowsPerPage}`
                            );
                            }}
                          >
                            Calendar
                          </span>
                          {![1, 2, 4].includes(medium.current_mediumship_level) && (
                            <span
                            onClick={(e) => {
                              e.stopPropagation();
                              window.renderFirst = false;
                              navigate(
                              `/backfill-view/${medium.id}?view=0&search=${filterValues}&searchName=${Object.values(searchValue)}&page=${info.page}&rowperpage=${info.rowsPerPage}&searchOprator=${showOprater}&searchFilterOprater=${filterOprater}`
                              );
                            }}
                            >
                            BackFill
                            </span>
                          )}
                          <span
                            onClick={(e) => {
                            e.stopPropagation();
                            navigateUser(medium);
                          }}
                        >
                          View
                        </span>
                        <span
                            onClick={(e) => {
                            e.stopPropagation();
                            navigateUserPricing(medium);
                          }}
                        >
                          Pricing
                        </span>

                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            updateUser(
                              medium,
                              parseInt(medium.status_name) === 4 ? 1 : 4,
                              "medium",
                              ""
                            );
                          }}
                        >
                          {parseInt(medium.status_name) === 4
                            ? "UnRestrict"
                            : "Restrict"}
                        </span>
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            updateUser(medium, 2, "mediums", "");
                          }}
                        >
                          Decline
                        </span>

                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            updateUser(medium, 3, "delete", "");
                          }}
                        >
                          Delete
                        </span>
                      </div>
                    )}
                  </td> */}
                  {/* <td className="dot-image">
                    <img src="../images/Unionblck.png" />
                  </td> */}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={10} style={{ padding: '48px 0', textAlign: 'center' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="8" r="4" stroke="#d5a67b" strokeWidth="1.5"/>
                      <path d="M4 20c0-4 3.582-7 8-7s8 3 8 7" stroke="#d5a67b" strokeWidth="1.5" strokeLinecap="round"/>
                      <line x1="8" y1="8" x2="16" y2="8" stroke="none"/>
                    </svg>
                    <p style={{ margin: 0, fontSize: '15px', fontWeight: '600', color: '#485257' }}>No mediums found</p>
                    <p style={{ margin: 0, fontSize: '13px', color: '#aaa' }}>Try adjusting your filters or load all records</p>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {/* <div className="pagination-box">
          <div className="left-pagi">
            <span>Showing 1 to 10 of 18 entries</span>
          </div>
          <div className="right-pagi">
            <ul>
              <li>Previous</li>
              <li className="active">
                <a href="#">1</a>
              </li>
              <li>
                <a href="#">2</a>
              </li>
              <li>
                <a href="#">3</a>
              </li>
              <li>Next</li>
            </ul>
          </div>
        </div> */}

      </div>
      <Pagination
        rowsPerPageOptions={[25, 50, 100]}
        count={allMediumCountPage}
        activeTab={"medium"}
        mediumpage={mediumpage}
        mediumrowsPerPage={mediumrowsPerPage}
        getPaginationData={getPaginationData}
      />
      {/* <div ><PaginatedItems itemsPerPage={5}/></div> */}
      <MediumInfoPanel
        medium={panelMedium}
        details={panelDetails}
        detailsLoading={panelLoading}
        onClose={() => setPanelMedium(null)}
        actions={panelActions}
      />
    </>
  );
}
